export function transformStringMapValuesToPaths<T>(
  obj: Record<string, any>,
  prependingPath = '',
): T {
  const newObj = {} as Record<string, any>;
  Object.entries(obj).forEach(([key, value]) => {
    const path = `${prependingPath}${key}`;
    if (typeof value === 'string') {
      newObj[key] = path;
    } else {
      newObj[key] = transformStringMapValuesToPaths(value, `${path}.`);
    }
  });
  return newObj as T;
}
